<template>
  <div style="background-color: white; text-align: center; padding-top: 3.5vh; padding-bottom: 6.5vh;">
    <hr>
    <div class="px-4">
      <!-- <p style="padding-top: 3vh;">Pink Nannies -- Richfield, OH 44286 -- 216 309 2322 -- info@pinknannies.com</p> -->
      <img class="mt-4 footer-logo" :src="require(`../../assets/img/logo/${$store.getters.logo}`)" alt="">
    </div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      email: '',
      emailEmployer: '',
      emailCandidate: '',
      justSubscribed: false,
    }
  },
  methods: {
    subscribeMailinglist(category) {

      // https://www.npmjs.com/package/vue-loading-overlay
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false,
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide()
      },2000)

      let email = ''
      if (category == 'Employer') {
        email = this.emailEmployer
      }
      if (category == 'Candidate') {
        email = this.emailCandidate
      }

      axios.post('/api/mailinglist/', {
        // email: this.email,
        email: email,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
        category: category,
      })
        .then(res => {
          console.log(res)
          this.justSubscribed = true
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style>
  .footer-logo {
    max-width: 225px;
  }
</style>



// WEBPACK FOOTER //
// src/components/global/Footer.vue